import { useQueryClient } from '@tanstack/react-query'

import { getStatusOptions } from '../../notification/services/useStatusQuery'
import { getConversationsPreviewOptions } from './useConversationsPreviewQuery'

export const useMarkConversationAsRead = () => {
  const queryClient = useQueryClient()

  return (conversationId: number) => {
    queryClient.cancelQueries({ queryKey: getConversationsPreviewOptions().queryKey })
    queryClient.cancelQueries({ queryKey: getConversationsPreviewOptions({ unread: true }).queryKey })

    queryClient.setQueryData(getConversationsPreviewOptions().queryKey, (old) => {
      if (!old) return old
      return {
        ...old,
        pages: old.pages.map((page) =>
          page.map((conversation) =>
            conversation.id === conversationId ? { ...conversation, hasUnreadMessages: false } : conversation,
          ),
        ),
      }
    })

    queryClient.setQueryData(getConversationsPreviewOptions({ unread: true }).queryKey, (old) => {
      if (!old) return old
      return {
        ...old,
        pages: old.pages.map((page) => page.filter((conversation) => conversation.id !== conversationId)),
      }
    })

    queryClient.invalidateQueries({ queryKey: getStatusOptions().queryKey })
  }
}
